// Write your JS code here
import {Link} from 'react-router-dom'

import './index.css'

const BlogItem = props => {
  const {blogDetails} = props
  const {id, title, imageUrl, avatarUrl, author, topic} = blogDetails
  return (
    <Link to={`/blogs/${id}`} className="link-item">
      <li className="blog-item">
        <img src={imageUrl} className="image" alt={title} />
        <div className="blog-item-container">
          <p className="topic">{topic}</p>
          <h1 className="title">{title}</h1>
          <div className="author-profile">
            <img src={avatarUrl} className="avatar-image" alt={author} />
            <p className="author">{author}</p>
          </div>
        </div>
      </li>
    </Link>
  )
}
export default BlogItem
